<template>
  <div class="History">
    
      <b-row>
        <b-col>
          <h3 class="mb-3 text-left" >
             Saldo total:
            <span style="color: black" 
              >$ {{amount}}</span
            >
          </h3>
        </b-col>
        <b-col>
          <h3 class="mb-3 text-right">
            Historial
          </h3>
        </b-col>
      </b-row>  
    
    <b-card
      header-tag="header"
      header-class="card-color"
      class="mb-4"
      style="border-radius: 15px"
    >
      <template #header>
        <b-row align-v="center" align-h="between">
          <b-col lg="8" md="8" sm="8" cols="6">
            <div class="text-left card-title-white">
              Historial de movimientos
            </div>
          </b-col>
          <b-col lg="3" md="3" sm="3" cols="6">
            <b-form-select
              v-model="id_account"
              :options="account"
              size="sm"
              class="shadow-sm rounded"
            ></b-form-select>
          </b-col>
        </b-row>
      </template>
      <b-card-text v-if="balance.length == 0 && id_account">
        No se han realizado movimientos en tu cuenta
      </b-card-text>
      <b-card-text v-if="!id_account"> Seleccione una cuenta </b-card-text>
      <b-card-text class="scroll" v-if="balance.length > 0">
        <b-list-group class="p-4" v-for="history of balance" :key="history.id">
          <b-row align-v="center">
            <b-col md="4 ">
              <h5
                class="text-light-black-title text-left"
              >
                {{history.type.name}}
              </h5>
              
              <div
                class="text-bold-black-title text-left"
                style="font-size: 15px"
              >
                {{history.status.name}}
              </div>
              
              <div
                class="text-bold-black-title text-left"
                style="font-size: 15px"
              >
                {{ history.created_at }}
              </div>
            </b-col>
            <b-col md="5"> </b-col>
            <b-col md="3">
              <h5
                class="mb-1 text-font-black text-right"
                style="font-size: 30px"
              >
                <span v-if="history.type_money_flow == 2">-</span> $ {{ history.amount }}
              </h5>
              <div class="mb-1 text-light-black-title text-right" style="font-size: 15px" v-if="history.accumulated_amount">
                    $ {{history.accumulated_amount}} <!-- <span v-if="history.status.id == 1"> - Pendiente: $ {{ history.account.overview.pending_incomes }}</span> --> 
                  </div>
            </b-col>
          </b-row>
        </b-list-group>
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Swal from "sweetalert2";
import Cookies from "js-cookie";

export default {
  name: "History",
  data() {
    return {
      id: Cookies.get("id"),
      balance: [],
      amount: 0,
      account: [{ value: null, text: "Seleccione una cuenta" }],
      id_account: null,
      update: null,
    };
  },
  methods: {
    ...mapActions(["getAccountForHistory", "getAccountInfo", "getBalanceAccount"]),

    AllAccount() {
      this.getAccountForHistory(this.id)
        .then((response) => {
          
          if (response.code == 200) {
           
            response.data.forEach((element) => {
              this.account.push({
                value: String(element.id),
                text: element.name,
              });
            });
            if (this.$route.path.substr(9, 10)) {
              this.id_account = this.$route.path.substr(9, 10);
              this.AllBalance();
            }
          }
        })
        .catch((error) => {
          console.log(error);
          Swal.fire({
            title: "Error",
            text: "Ha ocurrido un error, intente más tarde",
            icon: "error",
          });
        });
    },
    AllBalance() {
      console.log(this.id_account);
      this.getAccountInfo(this.id_account)
        .then((response) => {
          console.log(response);
          if (response.code == 200) {
            this.balance = response.data;
          }
        })
        .catch((error) => {
          console.log(error);
          Swal.fire({
            title: "Error",
            text: "Ha ocurrido un error, intente más tarde",
            icon: "error",
          });
        });
        this.getBalanceAccount(this.id_account)
        .then((response) => {
          console.log(response);
          if (response.code == 200) {
            this.amount = response.data.balance;
          }
        })
        .catch((error) => {
          console.log(error);
          Swal.fire({
            title: "Error",
            text: "Ha ocurrido un error, intente más tarde",
            icon: "error",
          });
        });
    },
  },
  computed: {
    ...mapState({
      me_user: (state) => state.me_user,
    }),
  },
  mounted() {
    this.AllAccount();
    console.log(this.$route.path.substr(9, 10));
  },
  updated() {
    if (this.id_account != null && this.id_account != this.update) {
      this.update = this.id_account;
      console.log("Balance");
      this.AllBalance();
    } else if (this.id_account == null && this.update != null) {
      this.balance = [];
      this.update = this.id_account;
    }
  },
};
</script>
<style scoped>
.scroll {
  overflow: auto;
  overflow-x: hidden;

  max-height: 400px;
}
.card-header:first-child {
  border-radius: 15px 15px 0 0;
}
</style>